import type { GetPendingChatRequests200ItemCurrentUserStatusStatus } from './getPendingChatRequests200ItemCurrentUserStatusStatus';

export type GetPendingChatRequests200ItemCurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: GetPendingChatRequests200ItemCurrentUserStatusStatus;
};
